import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from './types';

export interface ICacheStorage {
    open: (name: string) => Promise<Cache>;
    insert: (cache: Cache, request: Request, response: Response) => Promise<void>;
    exists: (cache: Cache, request: Request) => Promise<boolean>;
}

export function injectCacheStorage(
    container: IContainer = injectOrBuildContainer(),
): ICacheStorage {
    return container.get<ICacheStorage>(TYPES.ICacheStorage);
}

export function bindCacheStorage(
    val: ICacheStorage,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<ICacheStorage>(TYPES.ICacheStorage, val);
}

export function unbindCacheStorage(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.ICacheStorage);
}
